import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PAYMENT_TEST_FILTERS, type PaymentTestFilter } from '../../types';

export interface PaymentTestFilterSelectProps {
  value: PaymentTestFilter;
  onChange: (value: PaymentTestFilter) => void;
}

/**
 * Фильтр «Платежи»: Реальные / Тестовые / Все — параметр `testFilter` экранов платежей
 * (`/admin/payments*`, рефералы пользователя). Оформлен как соседние Select строки фильтров.
 */
export const PaymentTestFilterSelect: React.FC<PaymentTestFilterSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <FormControl size="small" sx={{ minWidth: 130 }}>
      <InputLabel>{t('admin:payments.testFilter.label')}</InputLabel>
      <Select
        value={value}
        label={t('admin:payments.testFilter.label')}
        onChange={(e) => onChange(e.target.value as PaymentTestFilter)}
      >
        {PAYMENT_TEST_FILTERS.map((f) => (
          <MenuItem key={f} value={f}>{t(`admin:payments.testFilter.${f}`)}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PaymentTestFilterSelect;
